import React from 'react';
import createReactClass from 'create-react-class';

var SubmitButton = createReactClass({
  getDefaultProps(){
    return {
      canSubmit: false,
      title: 'Speichern',
    };
  },

  render() {
    return (
      <input className="btn btn-primary" formNoValidate={true} type="submit" defaultValue={this.props.title} disabled={!this.props.canSubmit} />
    );
  }
});

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/common/Forms/SubmitButton.js